import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const TypographyOverflowEllipsis = styled(Typography)`
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
    whiteSpace: "nowrap",
`;
